const Footer = () => (
  <footer 
    className="bg-gradient-to-b from-[#dcecf8] to-[#ffffff] text-center py-4 text-sm text-gray-500 border-t w-full">
    Copyright © {new Date().getFullYear()}. Viswa Digital. All Rights Reserved.
  </footer>
);

export default Footer;
